"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");
/*
    Default Context
    Default context for Treble Container (non-scoped).
*/


var defaultValue = [];
var Context = (0, _react.createContext)(defaultValue);
var _default = Context;
exports["default"] = _default;
module.exports = exports["default"];